import { render, staticRenderFns } from "./CaseSubmissionForm.vue?vue&type=template&id=1c27525a&scoped=true&"
import script from "./CaseSubmissionForm.vue?vue&type=script&lang=js&"
export * from "./CaseSubmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./CaseSubmissionForm.vue?vue&type=style&index=0&id=1c27525a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27525a",
  null
  
)

export default component.exports